import Routes from './components/routes/Routes';

const App = () => {
  return <Routes />;
};

export default App;
